import Send from '../../send';

const DEFAULT_API = '/v1/education-info';
export default {
    getEducationInfos(siteInfoSeq) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'GET',
            params : {
                siteInfoSeq : siteInfoSeq
            }
        });
    },

    createEducationInfo(createEducationInfoDTO) {
        return Send({
            url : `${DEFAULT_API}`,
            method : 'POST',
            data : createEducationInfoDTO
        });
    },

    // updateTermsInfo(seq, termsInfoDTO) {
    //     return Send({
    //         url : `${DEFAULT_API}`,
    //         method : 'PUT',
    //         data : termsInfoDTO
    //     });
    // },
    //
    // deleteTermsInfo(seq) {
    //     Send({
    //         url : `${DEFAULT_API}`,
    //         method : 'DELETE',
    //         params : {
    //             termsInfoSeq : seq
    //         }
    //     });
    // }
}